var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from '../../../interface/IVueDialog';
import CommonService from '../../../api/CommonService';
import { EExportTemplateType } from '../../../enum/EExportTemplateType';
import _ from 'lodash';
import { UrlHelper } from "../../../helper/UrlWrapper";
var CustomExportWrap = (function (_super) {
    __extends(CustomExportWrap, _super);
    function CustomExportWrap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.orderIds = [];
        _this.listData = {};
        _this.remember = true;
        _this.activeName = '1';
        _this.transData = [];
        _this.checkedData = [];
        return _this;
    }
    CustomExportWrap.prototype.created = function () {
        this.orderIds = this.orderIds;
        this.commonService = CommonService.getInstance();
        this.getExportDetail();
    };
    CustomExportWrap.prototype.getExportDetail = function () {
        var _this = this;
        this.commonService.getExportDetail({
            template_type: EExportTemplateType.Bill
        }).then(function (res) {
            _this.listData = res.data.data;
            _this.activeName = _this.listData.table_header_column[0].type + '';
            _this.handleCheckedChange();
            _this.getCheckedData();
        });
    };
    CustomExportWrap.prototype.handleCheckedChange = function () {
        var _this = this;
        this.listData.table_header_column.forEach(function (item) {
            var tempList = item.data.map(function (item1) {
                return item1.name;
            });
            var titleList = _.uniq(tempList);
            var list = [];
            titleList.forEach(function (item1) {
                var obj = {
                    title: item1,
                    list: item.data.filter(function (item2) {
                        return item2.name === item1;
                    })
                };
                list.push(obj);
            });
            _this.transData.push({
                title: item.title,
                type: item.type,
                subList: list
            });
        });
    };
    CustomExportWrap.prototype.getCheckedData = function () {
        var _this = this;
        this.transData.forEach(function (item) {
            var list = [];
            item.subList.forEach(function (item1, index) {
                var tempList = [];
                item1.list.forEach(function (item2) {
                    if (item2.is_hidden == 0) {
                        tempList.push(item2.value);
                    }
                });
                list.push(tempList);
            });
            _this.checkedData.push(list);
        });
    };
    CustomExportWrap.prototype.handleClick = function (tab, event) {
        this.activeName = tab.name;
    };
    CustomExportWrap.prototype.close = function () {
        this.$closeDialog();
    };
    CustomExportWrap.prototype.exportData = function () {
        var _this = this;
        this.listData.table_header_column.forEach(function (item, index) {
            var flattenCheckedList = _.flatten(_this.checkedData[index]);
            item.data.forEach(function (item1, index) {
                item1.is_hidden = flattenCheckedList.indexOf(item1.value) > -1 ? 0 : 1;
            });
        });
        this.commonService.updateExport({
            data: JSON.stringify(this.listData),
            remember: this.remember,
            template_type: EExportTemplateType.Bill
        }).then(function (res) {
            if (res.data.success) {
                _this.export();
            }
        }, function (err) {
            _this.$message.error(err.message);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    CustomExportWrap.prototype.export = function () {
        window._czc.push(["_trackEvent", '客户对账单导出', '客户对账单导出']);
        var url = "supplierclientapi/statementorder/export?order_id=" + this.orderIds.join(",");
        url = UrlHelper.addParam(url, 'token', this.token);
        location.href = url;
    };
    CustomExportWrap = __decorate([
        Component
    ], CustomExportWrap);
    return CustomExportWrap;
}(VueDialog));
export default CustomExportWrap;
